import { DmbClient } from '../../model';

export type ClientTreeItem = DmbClient & { level: number };

// Depth-first, root-to-leaf order. "Root" means no visible parent in this list — not parent === 0 — so
// a client the user can see without seeing its parent still surfaces at the top level. excludeId drops
// one client from the result while still traversing into its children.
export function buildClientTree(clientList: DmbClient[], excludeId?: number): ClientTreeItem[] {
  const ids = new Set(clientList.map((c) => c.id));
  const childrenByParent = new Map<number, DmbClient[]>();
  const roots: DmbClient[] = [];

  for (const client of clientList) {
    if (ids.has(client.parent)) {
      const children = childrenByParent.get(client.parent);
      if (children) {
        children.push(client);
      } else {
        childrenByParent.set(client.parent, [client]);
      }
    } else {
      roots.push(client);
    }
  }

  const result: ClientTreeItem[] = [];
  const stack = roots.reverse().map((client) => ({ client, level: 0 }));

  while (stack.length > 0) {
    const { client, level } = stack.pop() as { client: DmbClient; level: number };
    if (client.id !== excludeId) {
      result.push({ ...client, level });
    }
    const children = childrenByParent.get(client.id) ?? [];
    for (let i = children.length - 1; i >= 0; i--) {
      stack.push({ client: children[i], level: level + 1 });
    }
  }

  return result;
}
